export default __webpack_public_path__ + "static/mastercard-b5f715b033b1b30aa4207c1f18de54f4.jpg";